import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { darkMode, lightMode } from './styleConstants';

const ThemeContext = createContext({
  theme: lightMode,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleTheme: () => {},
});

/**
 * Returns the current theme object and toggle function from the nearest `ThemeProvider`.
 *
 * @returns The current `{ theme, toggleTheme }` context value.
 */
export const useThemeContext = () => useContext(ThemeContext);

/**
 * Provides the current light/dark theme object and a toggle function to descendants via React context.
 *
 * @param children - The subtree that should have access to the theme context.
 */
export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<any>(lightMode);

  const toggleTheme = () => {
    setTheme((prevTheme: any) => (prevTheme.theme === darkMode.theme ? lightMode : darkMode));
  };

  const contextInterface = useMemo(
    () => ({
      theme,
      toggleTheme,
    }),
    [theme]
  );
  return (
    <ThemeContext.Provider value={contextInterface}>
      {children}
    </ThemeContext.Provider>
  );
};
